import _extends from "@babel/runtime-corejs3/helpers/extends";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";

var _dec, _class;

import React, { PureComponent } from 'react';
import { styled, StyleSheet } from '@rexlabs/styling';
var defaultStyles = StyleSheet({
  arrow: {
    color: 'red',
    position: 'absolute',
    zIndex: 4,
    overflow: 'hidden',
    width: '2rem',
    height: '2rem',
    ':before': {
      content: ' ',
      position: 'absolute',
      width: '1rem',
      height: '1rem',
      background: 'white',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    }
  },
  arrowTop: {
    top: '100%',
    left: '50%',
    ':before': {
      top: 0,
      left: '50%',
      transform: 'translateX(-50%) translateY(-50%) rotate(45deg)'
    }
  },
  arrowBottom: {
    bottom: '100%',
    left: '50%',
    ':before': {
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%) translateY(50%) rotate(45deg)'
    }
  },
  arrowLeft: {
    left: '100%',
    top: '50%',
    ':before': {
      top: '50%',
      left: 0,
      transform: 'translateX(-50%) translateY(-50%) rotate(45deg)'
    }
  },
  arrowRight: {
    right: '100%',
    top: '50%',
    ':before': {
      top: '50%',
      right: 0,
      transform: 'translateX(50%) translateY(-50%) rotate(45deg)'
    }
  }
});
var Arrow = (_dec = styled(defaultStyles), _dec(_class =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Arrow, _PureComponent);

  function Arrow() {
    _classCallCheck(this, Arrow);

    return _possibleConstructorReturn(this, _getPrototypeOf(Arrow).apply(this, arguments));
  }

  _createClass(Arrow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          arrowProps = _this$props.arrowProps,
          placement = _this$props.placement,
          s = _this$props.styles;
      return React.createElement("div", _extends({
        ref: arrowProps.ref,
        style: arrowProps.style
      }, s('arrow', {
        arrowTop: _startsWithInstanceProperty(placement).call(placement, 'top'),
        arrowBottom: _startsWithInstanceProperty(placement).call(placement, 'bottom'),
        arrowLeft: _startsWithInstanceProperty(placement).call(placement, 'left'),
        arrowRight: _startsWithInstanceProperty(placement).call(placement, 'right')
      })));
    }
  }]);

  return Arrow;
}(PureComponent)) || _class);
export default Arrow;